import React from 'react';
import { useParams } from 'react-router-dom';
import styles from './action-pages.module.css';

export default function BharatBioScience(){
    const string = useParams().string;

    const response = {
        ProductCode: "FG60359",
        ProductName: "SAFAL  71  100X100 GM",
        ProductDscrptn: "AMMONIUM SALT OF GLYPHOSATE 71% SG ",
        Plant: "SI01",
        StorageLocation: "SF02",
        ManufactureDate: "27-11-2024",
        ExpiryDate: "26-11-2026",
        BatchNo: "TASK240127",
        ValuatedUnrestrictedStock: "2500.000",
        CreatedDt: "28-11-2024",
        Qty: "10 KG",
        CartonId: "SI01-2309426632682",
        NumberOfCases: "250"
    }

    return (<>
        <div className={styles['bharat-bio-science-container']}>
            <h1>Bharat Bio Science</h1>
            <div className={styles['bharat-bio-science']}>
                <p>GIBB POWDER <span>GIBBERELLIC ACID 0.001% L</span></p>
                <ul>
                    <li><span>Product id:</span> {string}</li>
                    {response.ProductCode && <li><span>Product code:</span> {response.ProductCode}</li>}
                    {response.ProductName && <li><span>Product name:</span> {response.ProductName}</li>}
                    {response.ProductDscrptn && <li><span>Product description:</span> {response.ProductDscrptn}</li>}
                    {response.Plant && <li><span>Plant:</span> {response.Plant}</li>}
                    {response.StorageLocation && <li><span>Storage location:</span> {response.StorageLocation}</li>}
                    {response.ManufactureDate && <li><span>Manufacture date:</span> {response.ManufactureDate}</li>}
                    {response.ExpiryDate && <li><span>Expiry date:</span> {response.ExpiryDate}</li>}
                    {response.BatchNo && <li><span>Batch no:</span> {response.BatchNo}</li>}
                    {response.ValuatedUnrestrictedStock && <li><span>Valuated unrestricted stock:</span> {response.ValuatedUnrestrictedStock}</li>}
                    {response.PackQuantity && <li><span>Pack quantity:</span> {response.PackQuantity}</li>}
                    {response.CreatedDt && <li><span>Created date:</span> {response.CreatedDt}</li>}
                    {response.Qty && <li><span>Quantity:</span> {response.Qty}</li>}
                    {response.CartonId && <li><span>Carton id:</span> {response.CartonId}</li>}
                    {response.NumberOfCases && <li><span>Number of cases:</span> {response.NumberOfCases}</li>}
                </ul>
            </div>
        </div>
    </>)
}
